var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content web-order-list" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view === 'list'"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              { key: _vm.filterResetKey, staticClass: "section filter-bar" },
              [
                _c(
                  "div",
                  { staticClass: "wo-filter-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSearch }
                      },
                      [_vm._v("查询")]
                    ),
                    _c("el-button", { on: { click: _vm.onReset } }, [
                      _vm._v("重置")
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-check",
                          disabled: !_vm.canAccept
                        },
                        on: { click: _vm.onAcceptSelected }
                      },
                      [_vm._v("接单")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          icon: "el-icon-close",
                          disabled: !_vm.canReject
                        },
                        on: { click: _vm.openRejectBatch }
                      },
                      [_vm._v("拒绝")]
                    ),
                    _vm.selectedRows.length
                      ? _c("span", { staticClass: "wo-toolbar-tip" }, [
                          _vm._v(
                            "已选 " + _vm._s(_vm.selectedRows.length) + " 单"
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "wo-filter-fields" },
                  [
                    _c("el-input", {
                      staticClass: "wo-filter-item",
                      attrs: { placeholder: "订单编号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onSearch($event)
                        }
                      },
                      model: {
                        value: _vm.filter.orderNo,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "orderNo", $$v)
                        },
                        expression: "filter.orderNo"
                      }
                    }),
                    _c("el-input", {
                      staticClass: "wo-filter-item",
                      attrs: { placeholder: "客户业务编号", clearable: "" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onSearch($event)
                        }
                      },
                      model: {
                        value: _vm.filter.businessNo,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "businessNo", $$v)
                        },
                        expression: "filter.businessNo"
                      }
                    }),
                    _c("cargo-advance-select", {
                      staticClass: "wo-filter-item",
                      attrs: {
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        filterable: "",
                        placeholder: "委托单位"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.filter.customerId = (p && p.value) || null
                        },
                        clear: function() {
                          _vm.filter.customerId = null
                        }
                      }
                    }),
                    _c("cargo-advance-select", {
                      staticClass: "wo-filter-item",
                      attrs: {
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        placeholder: "起运港 POL",
                        "custom-label": function(item) {
                          return "[" + item.code + "]" + item.englishName
                        },
                        "filter-tag-names": ["code", "englishName"],
                        "show-custom-label-in-option": true
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.filter.pol = (p && p.value) || ""
                        },
                        clear: function() {
                          _vm.filter.pol = ""
                        }
                      }
                    }),
                    _c("cargo-advance-select", {
                      staticClass: "wo-filter-item",
                      attrs: {
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        placeholder: "目的港 POD",
                        "custom-label": function(item) {
                          return "[" + item.code + "]" + item.englishName
                        },
                        "filter-tag-names": ["code", "englishName"],
                        "show-custom-label-in-option": true
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.filter.pod = (p && p.value) || ""
                        },
                        clear: function() {
                          _vm.filter.pod = ""
                        }
                      }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "wo-filter-item",
                        attrs: { placeholder: "订单状态", clearable: "" },
                        model: {
                          value: _vm.filter.orderStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "orderStatus", $$v)
                          },
                          expression: "filter.orderStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { value: 0, label: "待接单" }
                        }),
                        _c("el-option", {
                          attrs: { value: 1, label: "已接单" }
                        }),
                        _c("el-option", {
                          attrs: { value: 2, label: "已拒绝" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        staticClass: "wo-filter-item",
                        attrs: { placeholder: "订舱预审状态", clearable: "" },
                        model: {
                          value: _vm.filter.bookingAuditStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "bookingAuditStatus", $$v)
                          },
                          expression: "filter.bookingAuditStatus"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { value: 0, label: "待审核" }
                        }),
                        _c("el-option", {
                          attrs: { value: 1, label: "已通过" }
                        }),
                        _c("el-option", {
                          attrs: { value: 2, label: "已拒绝" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: _vm.onReady
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.filter.total > 0,
                      expression: "filter.total > 0"
                    }
                  ],
                  attrs: {
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize,
                    "page-sizes": [10, 20, 30, 50, 100]
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.rejectDialog.visible,
            title: "批量拒绝订单",
            width: "460px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.rejectDialog, "visible", $event)
            }
          }
        },
        [
          _vm.rejectDialog.rows && _vm.rejectDialog.rows.length
            ? _c(
                "div",
                { staticStyle: { "margin-bottom": "10px", color: "#606266" } },
                [
                  _vm._v(" 即将拒绝 "),
                  _c("b", [_vm._v(_vm._s(_vm.rejectDialog.rows.length))]),
                  _vm._v(" 单："),
                  _c("br"),
                  _vm._l(_vm.rejectDialog.rows, function(r) {
                    return _c(
                      "span",
                      { key: r.uuid, staticStyle: { "margin-right": "8px" } },
                      [_vm._v(_vm._s(r.orderNo))]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 5,
              placeholder: "请输入拒绝原因（对所有选中订单生效）"
            },
            model: {
              value: _vm.rejectDialog.reason,
              callback: function($$v) {
                _vm.$set(_vm.rejectDialog, "reason", $$v)
              },
              expression: "rejectDialog.reason"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.rejectDialog.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmReject }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "detail",
              expression: "view === 'detail'"
            }
          ],
          staticClass: "web-order-detail"
        },
        [
          _c(
            "div",
            { staticClass: "section wo-detail-toolbar" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-back" },
                  on: { click: _vm.backToList }
                },
                [_vm._v("返回列表")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-check",
                    disabled: !_vm.canAcceptDetail
                  },
                  on: { click: _vm.onAcceptDetail }
                },
                [_vm._v("接单")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    icon: "el-icon-close",
                    disabled: !_vm.canRejectDetail
                  },
                  on: { click: _vm.openRejectDetail }
                },
                [_vm._v("拒绝")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading"
                }
              ],
              staticClass: "section wo-detail-body"
            },
            [
              _c("div", { staticClass: "wo-section-title" }, [
                _vm._v("基本信息")
              ]),
              _c(
                "el-form",
                {
                  staticClass: "wo-detail-form",
                  attrs: {
                    inline: true,
                    "label-position": "right",
                    "label-width": "96px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { value: _vm.detailForm.orderNo, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.orderStatusName(
                            _vm.detailForm.orderStatus
                          ),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户名称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.customerName,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务编号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.businessNo,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "贸易条款" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.tradeTerms,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订舱预审" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.auditStatusName(
                            _vm.detailForm.bookingAuditStatus
                          ),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联工作单" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { value: _vm.detailForm.jobNo, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.fmtDate(_vm.detailForm.dateCreated),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "wo-section-title" }, [
                _vm._v("运输信息")
              ]),
              _c(
                "el-form",
                {
                  staticClass: "wo-detail-form",
                  attrs: {
                    inline: true,
                    "label-position": "right",
                    "label-width": "96px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "船名" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.vesselName,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "航次" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { value: _vm.detailForm.voyage, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "船公司" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { value: _vm.detailForm.carrier, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "起运港" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.portName(_vm.detailForm.pol),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "目的港" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.portName(_vm.detailForm.pod),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "ETD" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.fmtDate(_vm.detailForm.etd),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "货好时间" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.fmtDate(_vm.detailForm.cargoReadyDate),
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "wo-section-title" }, [
                _vm._v("货物信息")
              ]),
              _c(
                "el-form",
                {
                  staticClass: "wo-detail-form",
                  attrs: {
                    inline: true,
                    "label-position": "right",
                    "label-width": "96px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "总件数(PCS)" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.totalPackages,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总毛重(KGS)" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.totalGrossWeight,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总体积(CBM)" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.detailForm.totalVolume,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm.hasCifFields
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "HS编码" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.hsCode,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "中文品名" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.cnGoodsName,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "英文品名" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.enGoodsName,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "货值" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.cargoValue,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系人" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.contactPerson,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "邮编" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.deliveryZipCode,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "城市代码" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                value: _vm.detailForm.deliveryCityCode,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "派送地址" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "520px" },
                              attrs: {
                                value: _vm.detailForm.deliveryAddress,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _c("div", { staticClass: "wo-section-title" }, [
                _vm._v("箱型箱量")
              ]),
              _c(
                "el-table",
                {
                  staticClass: "wo-containers-table",
                  attrs: {
                    data: _vm.detailForm.containers,
                    border: "",
                    size: "small"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", label: "#", width: "50" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "containerType", label: "箱型" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "quantity", label: "箱量", width: "120" }
                  })
                ],
                1
              ),
              _vm.parties.length
                ? [
                    _c("div", { staticClass: "wo-section-title" }, [
                      _vm._v("收发通")
                    ]),
                    _c(
                      "el-row",
                      { attrs: { gutter: 12 } },
                      _vm._l(_vm.parties, function(p) {
                        return _c(
                          "el-col",
                          { key: p.title, attrs: { span: 8 } },
                          [
                            _c(
                              "div",
                              { staticClass: "party-card" },
                              [
                                _c("div", { staticClass: "party-title" }, [
                                  _vm._v(_vm._s(p.title)),
                                  p.code
                                    ? _c(
                                        "span",
                                        { staticClass: "party-code" },
                                        [_vm._v(" [" + _vm._s(p.code) + "]")]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._l(p.lines, function(line) {
                                  return _c(
                                    "div",
                                    {
                                      key: line.label,
                                      staticClass: "party-line"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "party-label" },
                                        [_vm._v(_vm._s(line.label) + "：")]
                                      ),
                                      _vm._v(_vm._s(line.value || "—") + " ")
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ]
                : _vm._e(),
              _vm.detailForm.rejectReason
                ? [
                    _c("div", { staticClass: "wo-section-title" }, [
                      _vm._v("拒绝原因")
                    ]),
                    _c("el-input", {
                      attrs: {
                        value: _vm.detailForm.rejectReason,
                        type: "textarea",
                        rows: 2,
                        disabled: ""
                      }
                    })
                  ]
                : _vm._e(),
              _vm.detailForm.remark
                ? [
                    _c("div", { staticClass: "wo-section-title" }, [
                      _vm._v("备注")
                    ]),
                    _c("el-input", {
                      attrs: {
                        value: _vm.detailForm.remark,
                        type: "textarea",
                        rows: 2,
                        disabled: ""
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }